import { MixpanelEvent, InteractionType, EventSource, ComponentType } from '../MixPanelTypes';

export type WorkerProfileEvents =
  | 'EDIT_ENGAGEMENT_SECTION'
  | 'CLICK_TAB_ITEM'
  | 'OPEN_ENGAGEMENTS_OVERFLOW_MENU'
  | 'EDIT_GENERAL_SECTION';

export const workerProfile: Record<WorkerProfileEvents, MixpanelEvent> = {
  CLICK_TAB_ITEM: {
    eventDescription: 'User has changed tab in the Worker Profile',
    eventKey: 'user-has-changed-view-in-the-worker-profile',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.TAB
  },
  OPEN_ENGAGEMENTS_OVERFLOW_MENU: {
    eventDescription: 'Open overflow menu for engagement',
    eventKey: 'open-overflow-menu-for-engagement',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.OVERFLOW_MENU_OPEN_BUTTON
  },
  EDIT_ENGAGEMENT_SECTION: {
    eventDescription: 'Edit Engagement section',
    eventKey: 'edit-engagement-section',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SMARTFORM_EDIT_BUTTON
  },
  EDIT_GENERAL_SECTION: {
    eventDescription: 'Edit General section',
    eventKey: 'edit-general-section',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SMARTFORM_EDIT_BUTTON
  }
} as const;
